module.exports = __webpack_public_path__ + "img/icon-water.1acdcbb1.png";